"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loader = void 0;
const Services_1 = __importDefault(require("../Services"));
class Loader {
    constructor($target, options = {}) {
        this.$target = $target;
        this.$overlayColor = (options.hasOwnProperty('overlayColor')) ? options.overlayColor : '#000000';
        this.$message = (options.hasOwnProperty('message')) ? options.message : 'لطفا کمی صبر کنید...';
        this.$state = (options.hasOwnProperty('state')) ? options.state : 'danger';
        this.$opacity = (options.hasOwnProperty('opacity')) ? options.opacity : 0.3;
        this.$size = (options.hasOwnProperty('size')) ? options.size : 'sm';
    }
    message(message) {
        this.$message = message;
        return this;
    }
    fire() {
        this.block(this.$target, {
            overlayColor: this.$overlayColor,
            state: this.$state,
            size: this.$size,
            opacity: this.$opacity,
            message: this.$message,
            overlayCSS: {
                zIndex: 1010,
            },
            borderRadius: 16
        });
    }
    down() {
        this.unblock(this.$target);
    }
    block(target, options) {
        let el;
        options = $.extend(true, {
            opacity: 0.05,
            overlayColor: '#000000',
            type: '',
            size: '',
            state: 'primary',
            centerX: true,
            centerY: true,
            message: '',
            shadow: true,
            width: 'auto'
        }, options);
        let html;
        const version = options.type ? 'spinner-' + options.type : '';
        const state = options.state ? 'spinner-' + options.state : '';
        const size = options.size ? 'spinner-' + options.size : '';
        const spinner = '<span class="spinner ' + version + ' ' + state + ' ' + size + '"></span>';
        if (options.message && options.message.length > 0) {
            const classes = 'blockui ' + (options.shadow === false ? 'blockui' : '');
            html = '<div class="' + classes + '"><span>' + options.message + '</span>' + spinner + '</div>';
            el = document.createElement('div');
            $('body').prepend(el);
            Services_1.default.addClass(el, classes);
            el.innerHTML = html;
            options.width = Services_1.default.actualWidth(el) + 10;
            Services_1.default.remove(el);
            if (target === 'body') {
                html = '<div class="' + classes + ' text-nowrap" style=""><span>' + options.message + '</span><span>' + spinner + '</span></div>';
            }
        }
        else {
            html = spinner;
        }
        const params = {
            message: html,
            centerY: options.centerY,
            centerX: options.centerX,
            css: {
                border: '0',
                padding: '0',
                backgroundColor: 'none',
                width: options.width,
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)'
            },
            overlayCSS: {
                backgroundColor: options.overlayColor,
                opacity: options.opacity,
                cursor: 'wait',
                zIndex: options.zIndex ? options.zIndex : (target === 'body' ? 1000 : 10),
                borderRadius: (options.borderRadius ? options.borderRadius : 0) + 'px',
            },
            onUnblock: function () {
                if (el && el[0]) {
                    Services_1.default.css(el[0], 'position', '');
                    Services_1.default.css(el[0], 'zoom', '');
                }
            }
        };
        if (target === 'body') {
            params.css.top = '50%';
            $.blockUI(params);
        }
        else {
            el = $(target);
            el.block(params);
        }
    }
    unblock(target) {
        if (target && target !== 'body') {
            $(target).unblock();
        }
        else {
            $.unblockUI();
        }
    }
    blockPage(options) {
        return this.block('body', options);
    }
    unblockPage() {
        return this.unblock('body');
    }
}
exports.default = Loader;
function loader(target = '', options = {}) {
    return new Loader(target, options);
}
exports.loader = loader;
